<template lang="html">

    <v-container>
        <h1>Legal Notice</h1>
      <br>
        <p>Julius Schulze<br />
            Westfalenstr. 4<br />
            33647 Bielefeld</p>

        <p>Phone number: +49 (0) 16092079402<br />
            Email: hallo@julius-schulze.de</p>

        <h5>Person responsible for content:</h5> Julius Schulze<p></p>
    </v-container>


</template>

<script lang="js">

    export default {
        name:     'imprint',
    }


</script>

<style scoped lang="scss">
    .impressum{

    }
</style>
